import type { AppConfig } from './types';

let appConfig: AppConfig | null = null;

export function setAppConfig(config: AppConfig): void {
  appConfig = config;
}

export function getAppConfig(): AppConfig {
  if (!appConfig) {
    throw new Error(
      '@elva/platform: App config not initialized. Call initPlatformApi(config) before using the platform.',
    );
  }
  return appConfig;
}
